export default __webpack_public_path__ + "static/media/gallery_03.73d2296f.jpg";